// Mirrors backend Propertelligent.Common.Enums.Communications.EmailSettingsTypesEnum. Not yet in the generated
// @propertelligent/client-api package. Single source of truth for both the personal (Messaging > Email,
// personalEmailApi.ts) and organization-level (My Organization > Email, organizationEmailApi.ts) SMTP/Gmail
// integrations -- previously each declared its own byte-for-byte-identical copy of this enum.
export enum EmailProviderType {
  None = 0,
  Gmail = 1,
  Office365 = 2,
  CustomPopSmtp = 3,
}
